/* Pick-or-add a TEAM (designs/intake-unified-form.md UF15, reshaped by
   teams-and-products.md TP5/TP8): the generic PickOrAdd over the team list,
   grouped Platform / Product / Other / Not filed yet. Adding posts only the
   NAME: the kind stays not recorded and the team waits for an Admin on the
   Teams section — guessing a kind would be a fabricated value. Storage stays
   the canonical list so dedup and +1 reach keep counting teams. */
import type { JSX } from "react";
import { byTeamGroup, teamGroupLabel, type CanonicalTeam } from "../../../shared/canonical-teams";
import { asJson } from "./api";
import type { FieldHelp } from "./form-help";
import { PickOrAdd, nearMatch, rankItems } from "./PickOrAdd";

export { nearMatch };
/* kept under its old name — the unit tests and the ranking contract predate
   the generic control */
export const rankTeams = (typed: string, teams: CanonicalTeam[]): CanonicalTeam[] =>
  rankItems(typed, teams);

export const addTeam = async (name: string): Promise<CanonicalTeam> =>
  asJson<CanonicalTeam>(
    await fetch("/api/intake/teams", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name }),
    }),
  );

export function TeamPicker({
  label,
  teams,
  value,
  onChange,
  onAdded,
  disabled = false,
  help,
}: {
  label: string;
  teams: CanonicalTeam[];
  value: string;
  onChange: (id: string) => void;
  onAdded: (team: CanonicalTeam) => void;
  disabled?: boolean;
  help?: FieldHelp;
}): JSX.Element {
  /* group order (a stable sort keeps the server's name order within each
     kind) so the UF15-a headings never split a kind in two */
  const ordered = byTeamGroup(teams);
  return (
    <PickOrAdd
      label={label}
      noun="team"
      items={ordered}
      value={value}
      onChange={onChange}
      onAdd={addTeam}
      onAdded={onAdded}
      disabled={disabled}
      testId="team-picker"
      help={help}
      groupOf={(t) => teamGroupLabel(t.kind)}
    />
  );
}
